// text.module
export const GET_TEXTS = 'getTexts'

// form.module
export const SEND_SMS = 'sendSms'

// profile.module
export const GET_ADDRESSES = 'getAddresses'
export const GET_ADDRESS_SUGGESTIONS = 'getAddressSuggestions'
export const SET_AREA = 'setArea'
export const GET_GEO_ADDRESS = 'getGeoAddress'
export const GET_INPUT_GEO_ADDRESS = 'getInputGeoAddress'
export const SET_PROFILE_ADDRESS = 'setProfileAddress'

// guard.module
export const GUARD_INIT = 'guardInit'
export const GUARD_SORT_OUTLETS = 'guardSortOutlets'
export const GUARD_NEXT = 'guardNext'
export const GUARD_BACK = 'guardBack'
export const GUARD_DISABLE = 'guardDisable'
export const GUARD_CHECK_IIKO = 'guardCheckIiko'

// settings.module
export const GET_CONFIG = 'getConfig'
export const ENABLE_OVERLAY = 'enableOverlay'
export const DISABLE_OVERLAY = 'disableOverlay'
export const SET_GLOBAL_ERROR = 'setGlobalError'

// basket.module
export const UPDATE_BASKET = 'updateBasket'
export const ADD_TO_BASKET = 'addToBasket'
export const ADD_UPSELL_TO_BASKET = 'addToUpsellBasket'
export const GET_BASKET = 'getBasket'
export const CLEAR_BASKET = 'clearBasket'
export const CALC_RUSSIAN_POST = 'calcRussianPost'
export const CALC_CDEK = 'calcCdek'
export const CALC_TK_PEK = 'calcTkPek'
export const SET_EXPIRED_PRODUCTS = 'setExpiredProducts'


// outlet.module
export const FETCH_SEARCH = 'fetchSearch'
export const FETCH_OUTLET = 'fetchOutlet'
export const FETCH_OUTLET_ADDITIONAL = 'fetchOutletAdditional'
export const FETCH_TIMES = 'fetchTimes'
export const FETCH_PRODUCTS = 'fetchProducts'
export const SELECT_CATEGORY = 'selectCategory'

// order.module
export const MAKE_ORDER = 'makeOrder'
export const CALL_WAITER = 'callWaiter'
export const MAKE_BOOKING = 'makeBooking'
export const CHECK_IIKO = 'checkIiko'